__turbopack_context__.v({
  "cellContent": "wh7Sgq_cellContent",
  "mobileOrgInfo": "wh7Sgq_mobileOrgInfo",
  "nonDeductibleDonationsTable": "wh7Sgq_nonDeductibleDonationsTable",
  "nonDeductibleInfo": "wh7Sgq_nonDeductibleInfo",
  "summaryTable": "wh7Sgq_summaryTable",
});
